<template>
    <div class="task-list-page h100">
        <div class="header-container">
            <van-tabs v-model="active" @change="changeTabs">
                <van-tab
                    v-for="(item, index) in type"
                    :key="item.label"
                    :title="item.label"
                >
                    <base-list
                        :ref="`baseList${index}`"
                        :api="getApi"
                        :filter="{ ...item.filter, ...filter }"
                    >
                        <template v-slot:default="scope">
                            <task-list-item :data="scope.data" @handleClick="handleClick" />
                        </template>
                    </base-list>
                </van-tab>
            </van-tabs>
            <div class="filter" @click="showFilter = true">
                <img src="../../assets/icon/ICON-筛选@2x.png">
                <span>筛选</span>
            </div>
        </div>
        <van-popup v-model="showFilter" position="right" class="filter-bar h100">
            <div class="sub-title">
                <span>事项类型</span>
            </div>
            <div class="task-list-page-radio zlm-radio">
                <van-radio-group v-model="filter.shiXiangCode" direction="horizontal">
                    <van-radio
                        v-for="item in todoTypeList"
                        :key="item.value"
                        :name="item.value"
                        icon-size="14px"
                    >{{ item.label }}</van-radio>
                </van-radio-group>
            </div>
            <div class="sub-title">
                <span>项目类型</span>
            </div>
            <div class="task-list-page-radio zlm-radio">
                <van-radio-group v-model="filter.xmLeiXing" direction="horizontal">
                    <van-radio
                        v-for="item in projectType"
                        :key="item.value"
                        :name="item.value"
                        icon-size="14px"
                    >{{ item.label }}</van-radio>
                </van-radio-group>
            </div>
            <div class="footer-btn">
                <van-button round @click="resetFilter">重置</van-button>
                <van-button round type="primary" @click="onSearch">确定</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import { Tab, Tabs, RadioGroup, Radio, Popup, Button } from 'vant'
    const {
        taskListApi,
        mixin,
        type,
    } = require(`@/config/${process.env.VUE_APP_PROJECT}/taskList`)
    const { todoType } = require(`@/config/${process.env.VUE_APP_PROJECT}/todoType`)
    const { projectType } = require(`@/config/${process.env.VUE_APP_PROJECT}/projectType`)
    import baseList from '@/components/baseList'
    import taskListItem from '@/components/taskListItem'
    import store from '@/store'

    export default {
        name: 'TaskList',
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Popup.name]: Popup,
            [Button.name]: Button,
            baseList,
            taskListItem,
        },
        mixins: [mixin],
        data() {
            return {
                active: 0,
                showFilter: false,
                filter: {
                    shiXiangCode: '',
                    xmLeiXing: '',
                },
                getApi: taskListApi,
                type,
                todoType,
                todoTypeList: todoType.filter((t) => t.value !== ''),
                projectType,
            }
        },
        methods: {
            changeTabs() {
            },
            onSearch() {
                this.showFilter = false
                this.$refs[`baseList${this.active}`][0].refresh()
            },
            resetFilter() {
                this.filter = {
                    shiXiangCode: '',
                    xmLeiXing: '',
                }
            },
            handleClick(item) {
                const todoItem = this.todoType.find((t) => t.value && t.value.toString() === item.type.toString())
                const target = todoItem ? todoItem.target : ''
                const approveRecordId = item.approveRecordId || item.id
                const accessToken = store.state.token || ''

                this.$router.push({
                    name: 'TodoDetail',
                    query: {
                        hideBar: true,
                        target,
                        id: approveRecordId,
                        token: accessToken,
                    },
                })
            },
        },
    }
</script>

<style lang="scss">
.task-list-page {
  background-size: 100% 160px;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .header-container {
    position: relative;
    padding-top: 50px !important;
    display: flex;
    flex-direction: column;
  }
  .van-tab--active {
    font-weight: bold;
    color: #41c39e;
  }
  .van-tabs__nav {
    font-weight: bold;
  }
  .van-tabs {
    background: #ffffff;
    flex: 1;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  }
  .van-tab {
    flex: 1 !important;
    padding: 0;
  }
  .van-tabs__line {
    background-color: #41c39e !important;
    height: 3px !important;
    width: 40px !important;
    border-radius: 2px;
  }
  .filter {
    position: absolute;
    right: 16px;
    top: 10px;
    z-index: 10;
    display: flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 20px;
    color: #333;
    font-size: 14px;
    border: 1px solid #41c39e;
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }
  &-radio {
    padding: 16px 12px 12px;
    box-sizing: border-box;
    height: 60vh;
    overflow: auto;
  }
  .filter-bar {
    width: 280px;
    .title {
      font-weight: bold;
      font-size: 18px;
      padding-top: 40px;
      padding-left: 24px;
      color: #333333;
    }
    .sub-title {
      font-size: 14px;
      padding-top: 20px;
      padding-left: 24px;
      color: #666666;
      font-weight: 500;
    }
    .zlm-radio .van-radio[aria-checked="true"] {
      border: 2px solid #41c39e;
    }
    .zlm-radio .van-radio .van-radio__icon--checked + .van-radio__label {
      color: #41c39e;
      font-weight: 500;
    }
    .van-radio__icon--checked .van-icon {
      background-color: #41c39e;
      border-color: #41c39e;
    }
    .zlm-radio .van-radio {
      border-radius: 6px;
      background: #f5f5f5;
      margin: 6px 8px 6px 0;
      padding: 8px 12px;
    }
    .footer-btn {
      position: absolute;
      left: 0;
      bottom: 30px;
      width: 100%;
      text-align: center;
      .van-button {
        height: 44px;
        width: 110px;
        margin: 0 10px;
        font-size: 15px;
        border-radius: 22px;
      }
      .van-button--default {
        background-color: #f5f5f5;
        border: none;
        color: #666666;
      }
      .van-button--primary {
        background-color: #41c39e;
        border: none;
        box-shadow: 0 4px 12px rgba(65, 195, 158, 0.3);
      }
    }
  }
}
</style>
